import React, { Component, createRef } from 'react'
import { Link } from 'react-router'
import './index.less'
import { inject, observer } from 'src/core/store'
import { setDocumentTitle, setUidToken  } from 'src/helper/tool'
import langM from './lang'
import { getlangV2, setlang } from 'src/helper/getlang'
import { jumpToUser } from 'src/helper/webviewFun'
import score from 'src/helper/score'
import http from 'src/helper/http'
import CountDown from 'src/component/CountDown'
import RewardComp from './rewardComp'
import { toJS } from 'mobx'
import { history } from 'src/core/router'
@inject('store')
@observer

export default class extends Component {
  constructor(props) {
    super(props)
    this.monthlyStore = this.props.store.register('activity/monthly')
    
  }

  state = {
    lang: langM.zh,
    tabState: 1,
    ruleState: false,
    flag: false,
    language: "en",
    showModla:true,
  }

  async componentDidMount() {
    this.$logEvent("monthlyRankReward_main_screen")
  }

  async componentWillMount() {
    let { language } = this.props.location.query
    language =await getlangV2(language, langM)
    if (language =='tr') {
      setDocumentTitle('Aylık Sıralama Ödülü')
    }else{
      setDocumentTitle('Monthly Rank Reward')
    }
    this.setState({
      lang: setlang(language, langM),
      language: language
    })
    let uid = await setUidToken(this.props.location.query)
    this.getUidInfosss(uid)
    await this.RunOnStart(uid)
  }

  getUidInfosss = async(uid)=>{
    let res =await http.post('/web/MyAccountInfo', {uid})
    if (res.code == 0) {
      if (res.res.region == 'ar') {
        history.replace(`/app/roomsupport`)
      }else{
        this.setState({showModla:false})
      }
    }
  }

  RunOnStart = async (uid) => {
    this.setState({ uid: uid })
    this.monthlyStore.getWealthRw()
    this.monthlyStore.getCharmRw()
    this.monthlyStore.getRoomRw()
    this.monthlyStore.getCd()
  }


  bannerComp = () => {
    let { language } = this.state
    let timeComp = ({ langtxt, daytxt, day, hour, mi, se }) => {
      return (
        <div className="timer">
          <div className='cd'>
            {langtxt}:
          </div>
          <div className="d">
            {day}
          </div>
          <div className="dtxt">
            {daytxt}
          </div>
          <div className="h">
            {hour}
          </div>
          <div className='colon'>
            :
          </div>
          <div className="m">
            {mi}
          </div>
          <div className='colon'>
            :
          </div>
          <div className="s">
            {se}
          </div>
        </div>
      )
    }
    return (
      <div className={`${language == 'tr'?'tr-bg':language == 'ar'?'ar-bg':'en-bg'} mrr-banner-bg`}>
        <div className="mrr-cd">
          <CountDown lang={this.state.lang} language={this.state.language} leftTimestamp={this.monthlyStore.data.cd} slot={timeComp} />
        </div>
        <div className="mrr-btn-wrap" onClick={this.changeRuleState.bind(this, true)}>
          <div className="btn-bg"></div>
          <div className="btn-txt">{this.state.lang.rule}</div>
        </div>
      </div>
    )
  }

  tabBarComp = () => {
    let tabBar = [
      // { type: this.state.lang.recharge, id: 1 },
      { type: this.state.lang.glory, id: 1 },
      { type: this.state.lang.charm, id: 2 },
      { type: this.state.lang.room, id: 3 },
    ]
    return (
      <div className="mmr-tabbar-wrap">
        {
          tabBar.map((item) => {
            return (
              <div
                key={item.id}
                onClick={this.changeTabBarSate.bind(this, item.id)}
                className={`tab-item ${this.state.tabState == item.id ? 'tab-active' : ''}`}
              >
                {item.type}
              </div>
            )
          })
        }
      </div>
    )
  }

  RuleReminderComp = () => {
    return (
      <div className='mmr-rules-mark-wrap'>
        <div
          onClick={this.changeRuleState.bind(this, false)}
          style={{ display: this.state.ruleState ? 'block' : 'none' }}
          className={`mmr-rules-mark`}></div>
        <div
          onClick={this.changeRuleState.bind(this, false)}
          className={`mmr-rules-wrap ${this.state.ruleState ? "rule-wrap-active" : ""} ${this.state.flag ? "rule-wrap-inactive" : ""}`}
        >
          <div className="rules-top">{this.state.lang.rule}</div>
          <div className="rules-center">
            <div dangerouslySetInnerHTML={{ __html: this.state.lang.ruleContent || "" }}></div>
          </div>
          <div className="rules-bottom"></div>
        </div>
      </div>
    )
  }

  changeTabBarSate = (state) => {
    if (state == 1) {
      this.$logEvent("monthlyRankReward_wealth")
    }
    if (state == 2) {
      this.$logEvent("monthlyRankReward_charm")
    }
    if (state == 3) {
      this.$logEvent("monthlyRankReward_room")
    }
    this.setState({
      tabState: state
    })
  }

  changeRuleState = (state) => {
    if (state) {
      this.$logEvent("monthlyRankReward_rule")
    }
    if (state == false) {
      this.setState({
        flag: true
      })
    } else {
      this.setState({
        flag: false
      })
    }
    this.setState({
      ruleState: state
    })
  }

  goUser(id) {
    id && jumpToUser(id)
  }

  render() {
    let rList = toJS(this.monthlyStore && this.monthlyStore.data && this.monthlyStore.data.rList) || []
    let cList = toJS(this.monthlyStore && this.monthlyStore.data && this.monthlyStore.data.cList) || []
    let wList = toJS(this.monthlyStore && this.monthlyStore.data && this.monthlyStore.data.wList) || []
    let rwList = []
    if (this.state.tabState == 1) {
      rwList = wList
    }
    if (this.state.tabState == 2) {
      rwList = cList
    }
    if (this.state.tabState == 3) {
      rwList = rList
    }


    return (
      <div className={`monthly-rank-reward-wrap ${this.state.language == 'ar' ? 'langAr' : ''}`}>
       {this.state.showModla && <div className='showmoldwe'>
          <div className='showmkookdoe'>{this.state.lang.showNewske}</div>
        </div>}
        {this.bannerComp()}
        {this.tabBarComp()}

        {rwList && rwList.length > 0 && (
          <div className="mmr-last-month-winer-wrap">
            <div className="mmr-lmw-top">{this.state.lang.winer}</div>
            <div className="mmr-lmw-center">
              <div className="mmr-lmw-top-wrap">
                {rwList && rwList.length > 0 && (<div className="bor" onClick={this.goUser.bind(this, rwList.length > 0 && rwList[0].uid)}></div>)}
                {rwList && rwList.length > 0 && (
                  <img src={`${rwList.length > 0 && rwList[0].avatarurl || rwList.length > 0 && rwList[0].logourl || '/img/icon.png'}`} alt="" className="ava" />
                )}
                {
                  rwList && rwList.length > 0 && (
                    <div className="info">
                      <div className="name">{rwList.length > 0 && rwList[0].nickname || rwList.length > 0 && rwList[0].name || ''}</div>
                      <div className="id">{rwList.length > 0 && rwList[0].duid || ''}</div>
                      <div className="gold">{score(rwList.length > 0 && rwList[0].val) || ''}</div>
                    </div>
                  )
                }
              </div>
              <div className="mmr-lmw-center-wrap">
                <div className="mmr-lmw-two">
                  {rwList && rwList.length > 1 && (<div className="bor" onClick={this.goUser.bind(this, rwList.length > 1 && rwList[1].uid)}></div>)}
                  {rwList && rwList.length > 1 && (
                    <img src={`${rwList.length > 1 && rwList[1].avatarurl || rwList.length > 1 && rwList[1].logourl || '/img/icon.png'}`} alt="" className="ava" />
                  )}
                  {rwList && rwList.length > 1 && (
                    <div className="info">
                      <div className="name">{rwList.length > 1 && rwList[1].nickname || rwList.length > 1 && rwList[1].name || ''}</div>
                      <div className="id">{rwList.length > 1 && rwList[1].duid || ''}</div>
                      <div className="gold">{score(rwList.length > 1 && rwList[1].val) || ''}</div>
                    </div>
                  )}
                </div>
                <div className="mmr-lmw-three">
                  {rwList && rwList.length > 2 && (<div className="bor" onClick={this.goUser.bind(this, rwList.length > 2 && rwList[2].uid)}></div>)}
                  {rwList && rwList.length > 2 && (
                    <img src={`${rwList.length > 2 && rwList[2].avatarurl || rwList.length > 2 && rwList[2].logourl || '/img/icon.png'}`} alt="" className="ava" />
                  )}
                  {rwList && rwList.length > 2 && (
                    <div className="info">
                      <div className="name">{rwList.length > 2 && rwList[2].nickname || rwList.length > 2 && rwList[2].name || ''}</div>
                      <div className="id">{rwList.length > 2 && rwList[2].duid || ''}</div>
                      <div className="gold">{score(rwList.length > 2 && rwList[2].val) || ''}</div>
                    </div>
                  )}
                </div>
              </div>
              <div className="mmr-lmw-bottom-wrap"></div>
            </div>
            <div className="mmr-lmw-bottom"></div>
          </div>
        )
        }


        <RewardComp rwState={this.state.tabState} lang={this.state.lang} />

        {this.RuleReminderComp()}



        <div className="srcs" style={{ display: 'none' }}>
          <img src="/img/activity/monthlyRank/top.png" alt="" />
          <img src="/img/activity/monthlyRank/bottom.png" alt="" />
        </div>

      </div >
    )
  }
}



// WEBPACK FOOTER //
// src/pages/activity/monthly-rank/index.js